if (typeof Node === "function" && Node.prototype) {
	const originalRemoveChild = Node.prototype.removeChild;
	Node.prototype.removeChild = function <T extends Node>(this: Node, child: T): T {
		if (child.parentNode !== this) {
			return child;
		}
		return originalRemoveChild.call(this, child) as T;
	};

	const originalInsertBefore = Node.prototype.insertBefore;
	Node.prototype.insertBefore = function <T extends Node>(
		this: Node,
		newNode: T,
		referenceNode: Node | null,
	): T {
		if (referenceNode && referenceNode.parentNode !== this) {
			return newNode;
		}
		return originalInsertBefore.call(this, newNode, referenceNode) as T;
	};
}
